"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.afto781Schema = void 0;
const yup = __importStar(require("yup"));
exports.afto781Schema = yup.object().shape({
    id: yup.string().notRequired(),
    date: yup.string().nullable(),
    mds: yup.string().nullable(),
    serial: yup.string().nullable(),
    unitChargedForFlyingHours: yup.string().nullable(),
    harmLocation: yup.string().nullable(),
    missionDataRows: yup.array().nullable(),
    flightAuth: yup.string().nullable(),
    issuingUnit: yup.string().nullable(),
    aircrewDataRows: yup.array().nullable(),
    maintReview: yup.string().nullable(),
    pilotReviewA: yup.string().nullable(),
    pilotReviewB: yup.string().nullable(),
    pilotReviewC: yup.string().nullable(),
    pilotReviewD: yup.string().nullable(),
    pilotReviewE: yup.string().nullable(),
    pilotReviewF: yup.string().nullable(),
    sarmReview: yup.string().nullable(),
    armsInputInitials: yup.string().nullable(),
    armsInputDate: yup.string().nullable(),
    armsAuditInitials: yup.string().nullable(),
    armsAuditDate: yup.string().nullable(),
    printedName: yup.string().nullable(),
    rank: yup.string().nullable(),
    branchOfService: yup.string().nullable(),
    dsn: yup.string().nullable(),
    signature: yup.string().nullable(),
    eventId: yup.string().nullable(),
    aircrewDataRowsReverse: yup.array().nullable(),
    remarks: yup.string().nullable(),
    isLocked: yup.boolean().notRequired(),
});
